module.exports = __webpack_public_path__ + "img/tongguo.90a36f4b.png";